<div class="ostso-dialog landmark">
  <div class="header">
    <button mat-icon-button class="close-button" (click)="onNoClick()">
      <mat-icon>close</mat-icon>
    </button>
    <h1>{{ isNew ? "Создание пользователя" : "Редактирование пользователя" }}</h1>
  </div>
  <!--  <mat-expansion-panel class="=mat-elevation-z0" [expanded]="true" [style]="{'background-color': '#F3F4F6' }">-->
  <!--    <mat-expansion-panel-header>-->
  <!--      <mat-panel-title>-->
  <!--        Выбор роли-->
  <!--      </mat-panel-title>-->
  <!--    </mat-expansion-panel-header>-->
  <!--    <div>-->
  <!--      <div class="controls-buttons">-->
  <!--        @for (role of roles; track role.id) {-->
  <!--        <button-->
  <!--          class="control"-->
  <!--          mat-button-->
  <!--         >-->
  <!--          {{ role.name }}-->
  <!--        </button>-->
  <!--        }-->

  <!--      </div>-->
  <!--    </div>-->
  <!--  </mat-expansion-panel>-->
  <div mat-dialog-content>
    <mat-expansion-panel class="=mat-elevation-z0 rounded" [expanded]="true" [style]="{'background-color': '#F3F4F6' }">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <span class="gray">Выбор роли</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div>
        <div class="controls-buttons">
          @for (role of roles; track role.id) {
            <button
              class="control"
              mat-button
              [class.active]="currentRole?.name === role.name"
              (click)="currentRole = role"
            >
              {{ role.name }}
            </button>
          }
        </div>
      </div>
    </mat-expansion-panel>
    <div class="content">
      <form [formGroup]="mainForm" class="main-form">

        @if (currentRole?.code === "organization") {
          <div class="form-control__select-container" data-label="Учреждение">
            <select required formControlName="organization"
                    class="form-control__select">
              @for (option of organizations; track option.id) {
                <option [ngValue]="option">
                  {{ option.name }}
                </option>
              }
            </select></div>
        }
        @if (currentRole?.code === "department") {

          <div class="form-control__select-container" data-label="Подразделение">
            <select required formControlName="department"
                    class="form-control__select">
              @for (option of departments; track option.id) {
                <option [ngValue]="option">
                  {{ option.name }}
                </option>
              }
            </select></div>
        }

        <div class="form-control__container">
          <div class="form-control__label">Должность</div>
          <input type="text" formControlName="position" class="form-control__input" placeholder="Введите должность"/>
        </div>

        <div class="form-control__container" [class.error]="formControls['fio'].touched && formControls['fio'].invalid">
          <div class="form-control__label">ФИО</div>
          <input type="text" formControlName="fio" class="form-control__input" placeholder="Введите ФИО"/>
        </div>

        <div class="form-control__container" [class.error]="formControls['email'].touched && formControls['email'].invalid">
          <div class="form-control__label">Электронная почта</div>
          <input type="text" formControlName="email" class="form-control__input"
                 placeholder="Введите электронную почту"/>
        </div>

        <div class="form-control__container" [class.error]="formControls['phone'].touched && formControls['phone'].invalid">
          <div class="form-control__label">Телефон</div>
          <input type="text" formControlName="phone" class="form-control__input" placeholder="Введите телефон"/>
        </div>

        <div class="form-control__container" [class.error]="formControls['login'].touched && formControls['login'].invalid">
          <div class="form-control__label">Логин</div>
          <input type="text" formControlName="login" class="form-control__input" placeholder="Введите логин"/>
        </div>

        <div class="form-control__container" [class.error]="formControls['password'].touched && formControls['password'].invalid">
          <div class="form-control__label">Пароль</div>
          <input type="password" formControlName="password" class="form-control__input" placeholder="Введите пароль"/>
        </div>

      </form>
    </div>
  </div>
  <div mat-dialog-actions>
    <button class="btn btn-blue" mat-button cdkFocusInitial (click)="onApply()">Применить</button>
    <button class="btn btn-secondary" mat-button (click)="onNoClick()">Сбросить</button>
  </div>
</div>

